module.exports = __webpack_public_path__ + "static/undraw_getting_coffee_wntr-18c38ff9ef1c94440afdc047673ccbdf.svg";